import store from '@/store'

const onSortChange = async (value, model, filterAction) => {
  model.value.serverParams.ascending = value[0].type === 'asc'
  model.value.serverParams.orderByField = value[0].type === 'none' ? null : value[0].field
  await store.dispatch(filterAction, model.value)
}
export default onSortChange
